import { createStore } from '@/store'
const store = createStore()
export default store
